import React from 'react';
import './overview.css';
import Slider from '../../Home/Slider/Slider';
import overview1 from '../../Home/images/IMG_1569 (FILEminimizer).JPG';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faDesktop, faFlask, faBus, faPen, faClone } from '@fortawesome/free-solid-svg-icons';  // Using only free icons

const overview = () => {
  return (
    <div className='main-container-overview'>
        <Slider></Slider>
          <div data-aos="fade-up"
          data-aos-duration="3000">

        <div className='container-overview'>
        <h2>Best College in Faridabad <br />
            Overview
        </h2></div></div> <hr />
        <div className='box-1'> 
      
          <div data-aos="fade-up"
          data-aos-duration="2000">

        <div className='Name-of-container'>
            <img src={overview1} alt='over' className='overview1'/>  <hr />
            <div className='overview2'>
                <h1>The Institute</h1> <hr />
                <p>Pt. L. R. School od Pharmacy,Faridabad is the flagship Institution of Pt L.R Group of Insitution, promoted by Faridabad Educational Society, registered under the Registration of City Act 1860. The College was established in 2022 and has been conducting Diploma in Pharmacy courses.</p> 
                <p>Pt. L. R. School of Pharmacy is a  affiliated to Haryana State Board Technical Educatioon(HSBTE)Panchkula and approved by Pharmacy Council of India, New Delhi& DTE Haryana. The college provides a distinctive combination of academic excellence and professional ethics, designed to provide a strong foundation for the development of professional and personal life. The Pt. L. R. School of Pharmacy is envisioned as an institution that benefits a spectrum of career aspirants by providing need-based value added for all programs.</p>
            </div>  <hr />
        </div>
        </div>
        </div> <hr />
        <div data-aos="fade-up"
         data-aos-duration="3000">
        <div className='vision-boxes'>
        
          <div className='vision1'>
            <h1>Our Vision</h1> 
            <p>• To be a global centre of learning to promote professional excellence and innovation. <br /> <br />
          • To serve the local people in global arena. <br /> <br />
          • To build the nation and the society through providing integrated and trans-cultural quality education and to be the global front runner in value education</p></div>
        
         
           <div className='mission1'>
           
            <h1>Our Mission</h1> <br />
           
            <p>• All round personality development emphasises physical, practical, aesthetic, moral and intellectual development. <br /> <br />
            • To impart knowledge & skill-based education in collaboration with industry, academia & research organization. <br /> <br />
            • To explore and expand the human knowledge base. <br /> <br />
            </p>
        
          </div>
          </div>
         
       </div>
       <div data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="1500">
       <div className='ptlr'>
        <h1>Why PLRGI?</h1> 
       </div>
       </div><hr />
       <div data-aos="fade-up"
     data-aos-duration="3000">
       <div className='why-box1'> 
       <div data-aos="flip-left"
       data-aos-easing="ease-out-cubic"
       data-aos-duration="2000">


           <div className='TRAINING1'>
             <h1><FontAwesomeIcon icon={faCode} /> TRAINING</h1> <br />
              <p>We are committed to providing job-oriented practical training and building the high morale of our students through P.D.P. programmes, seminars and mock interviews, news etc. The students are motivated to prepare their projects with their hands as per the latest technology.</p>
           </div>
           </div>
           <div data-aos="flip-right"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000">

           <div className='VIRTUAL1'>
           <h1><FontAwesomeIcon icon={faDesktop} /> VIRTUAL LABS</h1> <br />
           <p>
           In the modern era of digital technology, students are being imparted practical education and shown working on various machines through virtual labs to save time. At the same time, the students are sent for internships to gain knowledge on the shop floor and face the challenges there.
           </p>
            </div>
            </div>

            <div data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000">
           <div className='CSR1'>
           <h1><FontAwesomeIcon icon={faFlask} /> C.S.R.</h1> <br />
            <p>We also discharge our responsibility towards society in raising the standard of living of rural people. To help needy students who cannot pay heavy tuition fees, we have sent our teaching staff to Coaching Centre to teach Pharmacy Subject like Human anatomy & Physiology, Pharmaceutics,Pharmaceutical chemistry,Bio-Chemistry,Social Pharmacy etc  so that the students get through.</p>
           </div>
           </div>
           <div data-aos="flip-right"
           data-aos-easing="ease-out-cubic"
           data-aos-duration="2000">
           <div className='TRIPS1'>
           <h1><FontAwesomeIcon icon={faBus} /> TRIPS</h1> <br />
           <p>Students are taken for Pharmaceutical education like  excursions like Industrial-cum-recreatioal trip regular to various places of interest. This brings more interaction between students with nature and society and thus helps in their overall development.</p>
           </div>
           </div>
           <div data-aos="flip-left"
             data-aos-easing="ease-out-cubic"
             data-aos-duration="2000">
           <div className='INTERNAL1'>
           <h1><FontAwesomeIcon icon={faPen} /> INTERNAL TESTS & ASSESSMENT</h1> <br /> 
           <p>We assess the students periodically through group discussions, workshops and Seminars, Industrial visits, and special classes by experts from Industry and University. All these activities boost students' energy levels in their curricular activities.</p>
           </div>
           </div>
           <div data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000">
           <div className='SCHOLARSHIP1'>
           <h1><FontAwesomeIcon icon={faClone} /> SCHOLARSHIP</h1> <br />
              <p>Eligible students will be entitled to a scholarship from the social welfare dept., Haryana, Tripura, Nepal, Bihar, Delhi. The Social welfare department provides fee refunds to financially weaker students of S.C. and O.B.C. categories.</p>
           </div>
           </div>

           </div>
       </div>
      
    </div>
   
  );
}

export default overview;

